<div class="cnt-row-centered btnCnt" data-testid="saveClosePane">

    <div [width]="20"></div>
    <simple-btn *ngIf="isValid"
             [horizontalPadding]="20"
             [text]="'SAVE' | translate"
             i18n-text
             (click)="saveHandler()"
             [textCls]="'large-btn-text'"
             [height]="40"
             [cornerRadius]="50"
             [backgroundFillCls]="'o2Background'"
             [hoverFillCls]="'o1Background'"
             [boxShadowCls]="'primary-shadow'"
             data-testid="saveclosepaneSaveBtn">
    </simple-btn>
    <simple-btn *ngIf="!isValid"
                [text]="'SAVE' | translate"
                i18n-text
                [horizontalPadding]="20"
                [textCls]="'large-btn-text'"
                [height]="40"
                [cornerRadius]="50"
                [backgroundFillCls]="'transparent-background'"
                [hoverFillCls]="'g4Background'"
                [borderWidth]=2
                [borderColorCls]="'g4Border'"
                [hoverBorderColorCls]="'g4Border'"
                [textColorCls]="'g4Color'"
                [hoverTextColorCls]="'white-color'"
                data-testid="saveclosepaneSaveBtn">
    </simple-btn>

    <ng-container *ngIf="saveClosePresent">
        <div [width]="10"></div>
        <simple-btn  [horizontalPadding]="20"
                 [text]="'SAVE_AND_CLOSE' | translate"
                 i18n-text
                 (click)="saveCloseHandler()"
                 [textCls]="'large-btn-text'"
                 [height]="40"
                 [cornerRadius]="50"
                 [backgroundFillCls]="'o2Background'"
                 [hoverFillCls]="'o1Background'"
                 [boxShadowCls]="'primary-shadow'"
                 data-testid="saveclosepaneSaveCloseBtn">
        </simple-btn>
    </ng-container>

    <div [width]="10"></div>
    <simple-btn [horizontalPadding]="20"
         [text]="'CANCEL_CHANGES' | translate"
         i18n-text
         (click)="cancelHandler()"
         [textCls]="'large-btn-text'"
         [height]="40"
         [cornerRadius]="50"
         [backgroundFillCls]="'transparent-background'"
         [hoverFillCls]="'g4Background'"
         [borderWidth]=2
         [borderColorCls]="'g4Border'"
         [hoverBorderColorCls]="'g4Border'"
         [textColorCls]="'g4Color'"
         [hoverTextColorCls]="'white-color'"
         data-testid="saveclosepaneCancelBtn">

    </simple-btn>
    <div class="filler"></div>

</div>